import Controller from "./fleetAdminManagement.controller";
import template from "./fleetAdminManagement.html";

const fleetAdminManagement = {
  template,
  controller: Controller,
  bindings: {
    managers: "<",
    addManager: "<",
    deleteManager: "<",
  },
};

export default fleetAdminManagement;



// WEBPACK FOOTER //
// ./src/components/fleetAdminManagement/fleetAdminManagement.component.js